// extracted by mini-css-extract-plugin
export var accountSwitcher = "pricing-module--account-switcher--XJnP8";
export var cardsBox = "pricing-module--cards-box--FwKUn";
export var cardsLabel = "pricing-module--cards-label--xG23j";
export var container = "pricing-module--container--W+nYL";
export var desktop = "pricing-module--desktop--VxPlD";
export var durationArrow = "pricing-module--duration-arrow--vMn6z";
export var durationLabel = "pricing-module--duration-label--SyF-q";
export var durationLabelText = "pricing-module--duration-label-text--r0BsV";
export var durationLabels = "pricing-module--duration-labels--eJ+f9";
export var hint = "pricing-module--hint--mEWuP";
export var mobile = "pricing-module--mobile--kFd5j";
export var paymentSwitcher = "pricing-module--payment-switcher--3FN2T";
export var range = "pricing-module--range--2EwrF";
export var settings = "pricing-module--settings--LxlZ2";
export var switcherButton = "pricing-module--switcher-button--l+eSF";
export var title = "pricing-module--title---dXWj";